<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90"><polygon fill="currentColor" points="0,48 10,35 36,57 78,10 90,21 37,79 "/><!-- Created by Zahroe from the Noun Project --></svg>
